export const getLineRange = (from, until) => from === until
    ? `${from}`
    : `${from} - ${until}`;

export const getLineText = (from, until) => from === until
    ? `Code flagged: line ${from}`
    : `Code flagged: from line ${from} until ${until}`;
